/* eslint-disable react/self-closing-comp */
import React from 'react'
import { useSelector } from 'react-redux'
import { Header, Message } from 'semantic-ui-react'

// material
import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'
import ConplaintView from '../components/complaint/ComplaintView'
// Menu
import Menu from '../components/Menu'
import ClientMenuLeft from './common/ClientMenuLeft'
// components
import Page from '../components/Page'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}))

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 1000,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0),
}))

// ----------------------------------------------------------------------

export default function ComplaintConfirmPage() {
  const { errorComplaint } = useSelector((state) => state.complaintReducer)
  const { complaint } = useSelector((state) => state.complaintReducer)

  return (
    <RootStyle title="Register | Gestion des plaintes">
      <Menu />

      <ClientMenuLeft />

      <Container>
        <ContentStyle>
          {' '}
          {errorComplaint && (
            <Message
              negative
              attached
              header="Il y avait quelques erreurs avec votre soumission!"
              content={errorComplaint}
            />
          )}
          {complaint && (
            <>
              <Message>
                <Header as="h2" color="blue">
                  Confirmation
                </Header>
              </Message>

              <ConplaintView complaint={complaint.payload} />
            </>
          )}
        </ContentStyle>
      </Container>
    </RootStyle>
  )
}
